<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Overview</div><v-divider class="div-after"/>
    <div class="body-1">
      For this checkpoint, I explored <span class="font-weight-bold">Adaptive Logarithmic Mapping</span> for
      tone reproduction. I noticed that the class slides ended up having a slightly different equation from
      the paper (LDmax instead of 1 was divided by the log10 component on the left-hand side). I went
      with the class slides and experimented with that left-hand component. I ultimately tried three
      different approaches with various biases/lighting.
    </div><v-divider class="spacer"/><div class="headline font-weight-bold">Preface - Ward</div><v-divider class="div-after"/>
    <div class="body-1">
      Some results from my Ward operator, just as a preface. Same lighting conditions as the rest of the base images.
      Unless otherwise, assume the remaining images have b = 0.85
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/10/9_ward_15.png`)"/>
      <div class="font-weight-medium">Ward where LD_MAX = 15</div>
      

    <v-divider class="spacer"/><div class="headline font-weight-bold">First Approach</div><v-divider class="div-after"/>
    <div class="body-1">
      For my first approach, I followed the equation in the slides to a T and ended up multiplying the original
      RGB values by the display luminance. I also normalized the RGB values from 0..1 according to the resultant
      RGB values, and got the following image. With brigher scene elements, other parts of the scene end up being
      dimmed in a way similar to my linear tone reproduction. Not 100% sure how I feel about this. 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/11/log_1.png`)"/>
      <div class="font-weight-medium">Approach 1 - Normalize</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Second Approach</div><v-divider class="div-after"/>
    <div class="body-1">
      For my second approach, I followed the slides and multiplied the original RGB values by the display luminance
      over the original pixel luminance (ld / lw). I also limited the values to 0..1 without normalization. The results 
      here seem reasonable, though at a certain point bias adjustments aren't very effective (above 1.0). 
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/11/log_2A.png`)"/>
      <div class="font-weight-medium">Approach 2 - Limit ld/lw where b = 0.85</div>
    <v-img class="u-image" :src="require(`../assets/updates/11/log_2A_1.png`)"/>
      <div class="font-weight-medium">Approach 2 - Limit ld/lw where b = 1</div>
    <v-img class="u-image" :src="require(`../assets/updates/11/log_2A_015.png`)"/>
      <div class="font-weight-medium">Approach 2 - Limit ld/lw where b = 0.15</div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Third Approach</div><v-divider class="div-after"/>
    <div class="body-1">
      For my third approach, I essentially did the same thing as the second approach without dividing ld by lw. I 
      kept the limit and didn't normalize, and got the following image. The image being a bit brighter and more
      washed out definitely makes sense. I find it interestng that this image is more similar to approach 2 with b = 0.15,
      yet the shadows in approach 2 are a little more intense!
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/11/log_2B.png`)"/>
      <div class="font-weight-medium">Approach 3 - Limit ld/1</div>

  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_11',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[11];
    },
  },
}
</script>

<style>

</style>
